/**
 * Rillion Prime API v1.0
 * A REST API endpoint for Role operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperationPermissionGroupEntity } from './operationPermissionGroupEntity';
import { RoleEntity } from './roleEntity';
import { RoleUserEntity } from './roleUserEntity';
import { RoleCompanyEntity } from './roleCompanyEntity';

export interface RoleAggregate {
  role?: RoleEntity;
  roleUser?: Array<RoleUserEntity> | null;
  roleCompany?: Array<RoleCompanyEntity> | null;
  operationPermissions?: Array<OperationPermissionGroupEntity> | null;
}
